export enum NoteType {
  NOTES = 'note',
  LOGBOOK = 'logbook',
}

export interface NotesSectionProps {
  isLoading: boolean;
  noteType?: NoteType;
}
